export const getStaticDelay = () => {
  return 1000;
};
